const WIDGET_PROP_TYPES = {
    STRING: 'string',
    NUMBER: 'number',
    BOOL: 'bool',
    IMAGE: 'image',
    DATETIME: 'dateTime',
    URL: 'url',
    COLOR: 'color',
};
const DATA_BINDING_FIELD_TYPES = {
    TEXT: 'text',
    IMAGE: 'image',
    BOOLEAN: 'boolean',
    NUMBER: 'number',
    DATETIME: 'datetime',
    RICHTEXT: 'richtext',
    COLOR: 'color',
    REFERENCE: 'reference',
    MULTI_REFERENCE: 'multi-reference',
    PAGELINK: 'pagelink',
    URL: 'url',
    DOCUMENT: 'document',
    VIDEO: 'video',
    ADDRESS: 'address',
    OBJECT: 'object',
    MEDIAGALLERY: 'media-gallery',
    TIME: 'time',
    AUDIO: 'audio',
};
const WIDGET_BINDING_MAP = {
    [WIDGET_PROP_TYPES.STRING]: [
        DATA_BINDING_FIELD_TYPES.TEXT,
        DATA_BINDING_FIELD_TYPES.NUMBER,
        DATA_BINDING_FIELD_TYPES.RICHTEXT,
        DATA_BINDING_FIELD_TYPES.IMAGE,
        DATA_BINDING_FIELD_TYPES.DATETIME,
        DATA_BINDING_FIELD_TYPES.URL,
        DATA_BINDING_FIELD_TYPES.AUDIO,
    ],
    [WIDGET_PROP_TYPES.NUMBER]: [DATA_BINDING_FIELD_TYPES.NUMBER],
    [WIDGET_PROP_TYPES.BOOL]: [DATA_BINDING_FIELD_TYPES.BOOLEAN],
    [WIDGET_PROP_TYPES.IMAGE]: [
        DATA_BINDING_FIELD_TYPES.URL,
        DATA_BINDING_FIELD_TYPES.IMAGE,
    ],
    [WIDGET_PROP_TYPES.DATETIME]: [DATA_BINDING_FIELD_TYPES.DATETIME],
    [WIDGET_PROP_TYPES.URL]: [DATA_BINDING_FIELD_TYPES.URL],
    [WIDGET_PROP_TYPES.COLOR]: [DATA_BINDING_FIELD_TYPES.COLOR],
};
export const getSupportedFieldTypesByPropType = (propType) => WIDGET_BINDING_MAP[propType] || [];
//# sourceMappingURL=dataBindingUtil.js.map